// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1DrZi","list":"BalanceDue_list__2xWx3","listRow":"BalanceDue_listRow__3gISt","total":"BalanceDue_total__3vm3z"};